/* Keep optional Shopify checkout warming close to purchase intent. */
(function () {
  'use strict';
  if (window.__florameCheckoutPrefetchBound) return;
  window.__florameCheckoutPrefetchBound = true;
  var warmed = false;
  var events = ['pointerover', 'focusin', 'touchstart'];
  function warm() {
    if (warmed) return;
    warmed = true;
    events.forEach(function (name) { document.removeEventListener(name, onIntent, true); });
    document.querySelectorAll('script[data-florame-checkout-prefetch]').forEach(function (source) {
      var url = source.getAttribute('data-florame-checkout-prefetch');
      var script = document.createElement('script');
      Array.prototype.forEach.call(source.attributes, function (attribute) {
        if (attribute.name !== 'data-florame-checkout-prefetch') script.setAttribute(attribute.name, attribute.value);
      });
      script.src = url;
      source.replaceWith(script);
    });
  }
  function onIntent(event) {
    var control = event.target?.closest?.('a[href],button[name="checkout"],button[data-florame-cart-trigger]');
    if (!control) return;
    if (control.tagName === 'A') {
      var url;
      try { url = new URL(control.href, location.href); } catch (_) { return; }
      if (url.origin !== location.origin || !/^\/(?:en\/|it\/)?(?:cart|checkout)\/?$/.test(url.pathname)) return;
    }
    warm();
  }
  events.forEach(function (name) { document.addEventListener(name, onIntent, { capture: true, passive: true }); });
})();
